
const themeV2 = {
  colors: {
    white: {
      primary: '#FFFFFF',
    },
    accent: {
      pink: {
        50: '#D705C0',
      },
    },
    brand: {
      primaryBlue: '#2E93EE',
      primaryLowLight: '#E7F3FD',
      primaryUltraLight: '#F3F9FF',
      primaryLight: '#74C1FF',
      primaryMedium: '#0070D1',
      primaryDark: '#1D5297',
      primaryExtraDark: '#1F2044',
      menuPrimaryMedium: '#1D5297',
      menuPrimaryDark: '#1F2044',
      gradientBlue: 'linear-gradient(90deg, #0070D1 0%, #0070D1 6.25%, #0271D2 12.5%, #0473D3 18.75%, #0775D4 25%, #0B78D5 31.25%, #107BD7 37.5%, #1680DA 43.75%, #1D84DC 50%, #258AE0 56.25%, #2D90E3 62.5%, #3796E7 68.75%, #419EEB 75%, #4DA5EF 81.25%, #59AEF4 87.5%, #66B7F9 93.75%, #74C1FF 100%)',
      snappyBlue: {
        5: '#001225',
      },
      snappyDarkOrange: {
        70: '#FF8C5C',
      },
    },
    neutral: {
      highPure: '#FFFFFF',
      highExtraLight: '#FAFAFA',
      highLight: '#F1F3F6',
      highMedium: '#CDD8DF',
      highDark: '#A6B6CC',
      lowPure: '#4A4A4A',
      lowLight: '#959EA3',
      lowMedium: '#707070',
      lowDark: '#363636',
      blackPure: '#000',
    },
    feedback: {
      pendingPure: '#FF9442',
      pendingUltraLight: '#FFF1E5',
      pendingLight: '#FFA464',
      pendingMedium: '#F67922',
      attentionPure: '#FFCF00',
      attentionUltraLight: '#FFFAE5',
      attentionLight: '#FFE885',
      attentionMedium: '#EEC100',
      attentionExtraDark: '#4D3F00',
      activePure: '#30B47A',
      activeUltraLight: '#EBFAF3',
      activeLight: '#35CF8B',
      activeMedium: '#2CA26E',
      activeDark: '#217A53',
      activeExtraDark: '#165238',
      problemPure: '#FC3C2B',
      problemUltraLight: '#FFE8E6',
      problemLight: '#F16A5E',
      problemMedium: '#DA4336',
      canceledPure: '#CDD8DF',
      canceledLight: '#F1F3F6',
      canceledMedium: '#A6B6CC',
    },
    gradient: {
      primary: 'linear-gradient(272deg, #0070D1 1.36%, #0070D1 7.48%, #0271D2 13.6%, #0473D3 19.72%, #0775D4 25.85%, #0B78D5 31.97%, #107BD7 38.09%, #1680DA 44.21%, #1D84DC 50.33%, #258AE0 56.46%, #2D90E3 62.58%, #3796E7 68.7%, #419EEB 74.82%, #4DA5EF 80.94%, #59AEF4 87.07%, #66B7F9 93.19%, #74C1FF 99.31%)',
      primaryReversed: 'linear-gradient(272deg, #74C1FF 1.36%, #66B7F9 7.48%, #59AEF4 13.6%, #4DA5EF 19.72%, #419EEB 25.85%, #3796E7 31.97%, #2D90E3 38.09%, #258AE0 44.21%, #1D84DC 50.33%, #1680DA 56.46%, #107BD7 62.58%, #0B78D5 68.7%, #0775D4 74.82%, #0473D3 80.94%, #0271D2 87.07%, #0070D1 93.19%, #0070D1 99.31%)',
      secondary: 'linear-gradient(94deg, #2E93EE 1.9%, #2E93EE 5.89%, #415ACA 40.83%, #5421A5 77.87%, #551CA2 83%, #2E1451 116.37%)',
      tertiary: 'linear-gradient(90deg, #2FEAA8 0%, #038DF3 100%)',
      tertiaryReversed: 'linear-gradient(90deg, #038DF3 0%, #2FEAA8 100%)',
      quaternary: 'linear-gradient(90deg, #fae20f 0%, #efa743 100%)',
      twilight: 'linear-gradient(90deg, #2E93EE 0%, #2E93EE 6.25%, #2F92ED 12.5%, #3091ED 18.75%, #3190EC 25%, #338EEB 31.25%, #358CE9 37.5%, #3789E8 43.75%, #3A86E6 50%, #3D83E4 56.25%, #417FE1 62.5%, #457BDF 68.75%, #4976DC 75%, #4E71D9 81.25%, #536CD5 87.5%, #5866D2 93.75%, #5E60CE 100%)',
    },
    aiChat: {
      overlay: '#1F204499',
    },
  },
  font: {
    family: {
      primary: "'Galano', 'Roboto',sans-serif,'Helvetica Neue',sans-serif",
    },
    weights: {
      light: 300,
      regular: 400,
      medium: 500,
      bold: 700,
    },
    sizes: {
      xxxs: '12px',
      xxs: '14px',
      xs: '16px',
      sm2: '18px',
      sm: '20px',
      md: '24px',
      lg: '30px',
      xl: '36px',
    },
    lineHeight: {
      text: '1.35em',
      title: '1.5em',
      description: '1.5em',
      list: '1.90em',
    },
  },
  breakpoints: {
    xs: '360px',
    sm: '600px',
    md: '960px',
    lg: '1280px',
    xl: '1920px',
  },
  layers: {
    hidden: -1,
    base: 0,
    header: 20,
    overlay: 30,
    modal: 40,
    awaysOnTop: 50,
    important: 99999,
  },
  shadows: {
    light: '0px 1px 3px #00000016',
    dark: '0px 3px 6px #00000020',
  },
};

export default themeV2;
